<template>
    <a-row class="n-h-1"
           align="middle"
           justify="space-between"
           :gutter="10">
        <a-col>
            <div>
                <i class="n-icon n-icon-open-panel"
                   v-if="collapsed"
                   @click="$emit('open')"></i>
                <i class="n-icon n-icon-close-panel"
                   @click="$emit('close')"
                   v-else></i>
            </div>
        </a-col>
        <a-col flex="1 1">
            <a-breadcrumb>
                <a-breadcrumb-item v-for="item in location"
                                   :key="item.key">{{item.title}}</a-breadcrumb-item>
            </a-breadcrumb>
        </a-col>
        <a-col>
            <User></User>
        </a-col>
    </a-row>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';

    import User from '@/components/User.vue'

    export default {
        name: 'Header',
        props: {
            collapsed: Boolean
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['location'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
            }
        }),
        components: {
            User
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
</style>